module.exports = "pegasus/assets/background-patterns/fall-space-theme.jpg";